import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'

import { DataModule } from '../data/data.module'
import { FirestoreService } from '../data/firestore.service'
import { ApiService } from '../data/api.service'

import { AuthService } from './auth.service'
import { AuthLoadGuard, AuthActivateGuard, AuthActivateChildGuard } from './auth.guard'

import { LoginComponent } from './login/login.component'
import { RecaptchaComponent } from './recaptcha/recaptcha.component'
import { ComponentsModule } from '../components/components.module'
import { PinComponent } from './pin/pin.component'

import { MaterialModule } from '../material/material.module'
import { PipesModule } from '../pipes/pipes.module'
import { ErrorScreenComponent } from './error-screen/error-screen.component'
import { SignInComponent } from './sign-in/sign-in.component';

@NgModule({
  imports: [
    DataModule,
    ComponentsModule,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    MaterialModule,
    PipesModule,
  ],
  declarations: [
    LoginComponent,
    RecaptchaComponent,
    PinComponent,
    ErrorScreenComponent,

    SignInComponent,
  ],
  entryComponents: [
    RecaptchaComponent
  ],
  providers: [
    AuthService,
    AuthLoadGuard,
    AuthActivateGuard,
    AuthActivateChildGuard,
    ApiService,
    FirestoreService,
  ],
  bootstrap: [
    LoginComponent
  ]
})
export class AuthModule { }
